"use client"

import { useContext, useMemo } from "react"
import { useFormatter as useIntlFormatter, useTimeZone } from "next-intl"
import { ClinicDateTimeContext } from "@/components/clinic-date-time-provider"
import { formatClockTime, withClinicDateTime } from "@/lib/clinic-date-time"

/** Staff-facing dates and clocks follow clinic settings; language stays personal. */
export function useFormatter() {
  const formatter = useIntlFormatter()
  const timeZone = useTimeZone()
  const { dateFormat, timeFormat } = useContext(ClinicDateTimeContext)
  // A clinic without its own time format keeps 24-hour clocks. Before these
  // views moved onto this formatter (2026-10) they printed fixed "HH:mm";
  // left to the language, an English UI turned every one into "2:30 PM".
  const clock = timeFormat ?? "24h"
  return useMemo(
    () => {
      const clinicFormatter = withClinicDateTime(formatter, { dateFormat, timeFormat: clock }, timeZone)
      return { ...clinicFormatter, clockTime: (value: string) => formatClockTime(clinicFormatter, value) }
    },
    [formatter, dateFormat, clock, timeZone],
  )
}
